import { FC, ReactNode } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { TypographyVariant } from "../../../constants/typography";
import { Dialog } from "../../core/Dialog/Dialog";
import { Typography } from "../../core/Typography/Typography";
import { YtbVideoPlayer } from "../YtbVideoPlayer/YtbVideoPlayer";
import { YtbThumbnailQuality } from "../../../models/media";
import { useStyles } from "./VideoPopupLayout.style";

type VideoPopupLayoutProps = {
  open: boolean;
  onClose?: () => void;
  videoUrl?: string;
  videoTitle?: string;
  videoFallback?: ReactNode;
  onVideoError?: () => void;
  thumbnailQuality?: YtbThumbnailQuality;
  qr?: {
    value: string;
    show: boolean;
    size?: number;
  };
  title: ReactNode;
  description?: ReactNode;
  actions: ReactNode;
};

export const VideoPopupLayout: FC<VideoPopupLayoutProps> = ({
  open,
  onClose,
  videoUrl,
  videoTitle,
  videoFallback,
  onVideoError,
  thumbnailQuality = "maxres",
  qr,
  title,
  description,
  actions,
}) => {
  const classes = useStyles();
  const showQrInline = !!qr?.show && !!qr?.value;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      hideLayout
      className={classes.rootLarge}
      data-dialog-nav="spatial"
    >
      <div className={classes.largeContent}>
        <div className={classes.videoWrap}>
          {videoUrl ? (
            <YtbVideoPlayer
              url={videoUrl}
              loop
              title={videoTitle}
              className={classes.videoLarge}
              onError={onVideoError}
              thumbnailQuality={thumbnailQuality}
            />
          ) : (
            videoFallback
          )}
        </div>
        <div className={classes.bottomBar}>
          <div className={classes.leftCol}>
            {showQrInline && (
              <QRCodeCanvas
                value={qr!.value}
                size={qr?.size ?? 80}
                bgColor="#FFFFFF"
                fgColor="#000000"
                level="L"
                marginSize={3}
                className={classes.qrCode}
              />
            )}
            <div className={classes.textCol}>
              <Typography
                variant={TypographyVariant.HeadingH3Bold}
                className={classes.titleLarge}
              >
                {title}
              </Typography>
              {description}
            </div>
          </div>
          <div className={classes.actionsLarge}>{actions}</div>
        </div>
      </div>
    </Dialog>
  );
};
